import { cn } from '@/utils/cn';
import { typographyVariants } from '@fleet/webshop-ui';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router-dom';

const linkVariants = cva(
  'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed',
  {
    variants: {
      size: {
        large: cn(typographyVariants({ variant: 'subtitle' })),
        medium: cn(typographyVariants({ variant: 'body1-bold' })),
        regular: cn(typographyVariants({ variant: 'button' })),
        small: cn(typographyVariants({ variant: 'body2' })),
      },
    },
    defaultVariants: {
      size: 'regular',
    },
  }
);

export interface LinkProps
  extends RouterLinkProps,
    VariantProps<typeof linkVariants> {
  asChild?: boolean;
  active?: boolean;
}

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (
    { className, size = 'regular', active = false, children, ...props },
    ref
  ) => {
    return (
      <RouterLink
        ref={ref}
        className={cn(
          linkVariants({ size }),
          'text-dark hover:text-primary-dark focus-visible:outline-tint',
          active && 'text-primary',
          className
        )}
        {...props}
      >
        {children}
      </RouterLink>
    );
  }
);

Link.displayName = 'Link';
